// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import model_1 from 'C:/GIT/CODE/dartsCloud/web/darts/src/models/globalState';
import model_2 from 'C:/GIT/CODE/dartsCloud/web/darts/src/.umi-production/plugin-initialState/@@initialState';

export const models = {
model_1: { namespace: 'globalState', model: model_1 },
model_2: { namespace: '@@initialState', model: model_2 },
} as const
